import { openConfirmDialogExternal } from '../components/common/Confirmer';

type ButtonType = 'success' | 'inherit' | 'primary' | 'secondary' | 'error' | 'info' | 'warning';

export default function confirm({
  title,
  message,
  onAnswer,
  type = 'primary',
  buttonText = 'OK',
}: {
  title: string;
  message: string;
  onAnswer: (answer: boolean) => void;
  type?: ButtonType;
  buttonText?: string;
}) {
  openConfirmDialogExternal({ title, message, onAnswer, type, buttonText });
}
